import APITokenEmpty from '@console/components/project/apiToken/Empty';
import APITokenTable from '@console/components/project/apiToken/Table';
import type {
  APITokenPropsMappedFromDispatch,
  APITokenPropsMappedFromState
} from '@console/containers/project/APITokenContainer';
import type { LocalAPIConfidentialInformation } from '@console/reducers/projects';
import type { Theme } from '@mui/material';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import type { ReactElement } from 'react';

const styles = (theme: Theme): StyleRules => ({
  sections: {
    paddingBottom: theme.spacing(5)
  },
  section: {
    paddingTop: theme.spacing(4)
  }
});

type APITokenProps = APITokenPropsMappedFromState &
  APITokenPropsMappedFromDispatch &
  WithStyles<typeof styles>;

const APIToken: React.FC<APITokenProps> = ({
  classes,
  apiConfidentialInformation
}) => {
  const renderContents = (): ReactElement<any> => {
    if (
      !!apiConfidentialInformation &&
      apiConfidentialInformation.accessTokens.length !== 0
    ) {
      return renderTable(apiConfidentialInformation.accessTokens);
    }

    return renderEmpty();
  };

  const renderTable = (
    accessTokens: LocalAPIConfidentialInformation['accessTokens']
  ): ReactElement<any> => <APITokenTable accessTokens={accessTokens} />;

  const renderEmpty = (): ReactElement<any> => <APITokenEmpty />;

  return (
    <div className={classes.sections}>
      <section className={classes.section}>{renderContents()}</section>
    </div>
  );
};

export default withStyles(styles)(APIToken);
